import React, { useCallback, useEffect, useState } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import MarketButton from 'components/commercetools-ui/organisms/market-button/market-button';
import { Reference } from 'types/reference';

export interface Props {
  text: string;
  highlightedSubstring: string;
  target?: Reference;
}

interface HeaderLink {
  id: string;
  text: string;
  target?: string;
  link: string;
  className?: string;
  icon?: string;
  Component?: React.ReactElement;
}

const AnnouncementBar: React.FC<Props> = ({ text, highlightedSubstring, ...props }) => {
  const [previewText, setPreviewText] = useState({ prefix: text, middle: '', suffix: '' });

  const processHighlighting = useCallback(() => {
    const start = text?.indexOf(highlightedSubstring);

    if (!highlightedSubstring || start === -1) {
      setPreviewText({ prefix: text, middle: '', suffix: '' });
      return;
    }

    const end = start + highlightedSubstring.length - 1;

    setPreviewText({
      prefix: text.substring(0, start),
      middle: text.substring(start, end + 1),
      suffix: text.substring(end + 1),
    });
  }, [text, highlightedSubstring]);

  useEffect(() => {
    processHighlighting();
  }, [processHighlighting]);

  const headerLinks: HeaderLink[] = [
    {
      id: 'visit.myamericangolf',
      text: 'Personalised Golf Products',
      link: 'https://www.myamericangolf.co.uk/',
      target: '_blank',
      className: '',
    },
    {
      id: 'book.custom.fitting',
      text: 'Book Custom Fitting',
      link: '/custom-fitting',
      className: '',
    },
    {
      id: 'store.locator',
      text: 'Store Locator',
      link: '/find-stores',
      className: 'underline hover:font-bold hover:no-underline',
      Component: <i className="icon icon-location"></i>,
    },
    {
      id: 'help.info',
      text: 'Help & Info',
      link: '/services',
      className: 'underline hover:font-bold hover:no-underline',
      Component: <i className="icon icon-info"></i>,
    },
  ];

  return (
    <div className="hidden w-full justify-center bg-white pb-10 pr-20 pt-12 lg:flex xl:pr-48">
      <div className="w-full max-w-7xl">
        {/** comment out for now */}
        {/* {isAnnouncement && (
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <p className="whitespace-nowrap text-center text-12 leading-loose text-black">
            {previewText.prefix}
            <Link link={target} className="underline underline-offset-2">
              {previewText.middle}
            </Link>
            {previewText.suffix}
          </p>
        </div>
      )} */}

        <div className="flex h-15 w-full items-center justify-end gap-20 bg-white">
          {headerLinks.map(({ id, text, target, link, className, Component }) => (
            <Link target={target} key={id} link={link} className="flex gap-2">
              {Component}
              <span className={`${className} text-[13px] font-medium leading-[14px] text-[#4b4b4b] hover:text-black`}>
                {text}
              </span>
            </Link>
          ))}
          <MarketButton />
        </div>
      </div>
    </div>
  );
};
export default AnnouncementBar;
